import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { mergeMap, switchMap } from 'rxjs/operators';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RuleTranslator } from '@cbridge-packages/rule';
import { RoutingRuleTranslator } from '../routingRule.translator';
import { RoutingRuleAction } from '../routingRule.action';

type IDependencies = IClientApiDependencySegment;

export const validateRoutingRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(RoutingRuleAction.validate.started),
  switchMap((params) => {
    const rules = params.map(RoutingRuleTranslator.toApi);
    return dependencies.api.validateRoutingRules({ rules }).pipe(
      mergeMap((response) => {
        return [
          RoutingRuleAction.validate.done({ params, result: (response.rules ?? []).map(RuleTranslator.fromApiValidation) }),
        ];
      }),
      catchApiError((error) => {
        return [
          RoutingRuleAction.validate.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
